import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'components';

import { formatUnitString } from 'utils/formatString';

import Status from '../Status';

const CtnInfoTable = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <Table
      data={data}
      config={{
        columns: [
          {
            name: 'detalization.postpaidInvoices.invoice.group',
            dataField: 'benNumber',
          },
          {
            name: 'detalization.postpaidInvoices.invoice.invoiceNumber',
            dataField: 'invoiceNumber',
          },
          {
            name: 'detalization.postpaidInvoices.invoice.amount',
            dataField: 'amount',
            transformer: ({ amount, currency }) => formatUnitString(amount, currency),
          },
          {
            name: 'detalization.postpaidInvoices.invoice.status',
            dataField: 'status',
            transformer: (row) => <Status {...row} />,
          },
        ],
        uniqueIdField: 'invoiceNumber',
      }}
    />
  );
};

CtnInfoTable.propTypes = {
  data: PropTypes.array,
};

export default CtnInfoTable;
